import React from 'react';
import PropTypes from 'prop-types';
import {ClassroomModelV1} from 'resources/augmented/Classroom/ClassroomModel.v1';

import {Modal} from '@albert-io/atomic';
import GenerateJoinCodeDialogue from 'client/components/GenerateJoinCodeDialogue/GenerateJoinCodeDialogue.react';

export default class ClassroomCodeRegenerator extends React.Component {
  static propTypes = {
    classroom: PropTypes.instanceOf(ClassroomModelV1).isRequired
  };

  constructor() {
    super();

    this.state = {
      showModal: false
    };
  }

  closeModal = () => this.setState({showModal: false});

  render() {
    return (
      <div className='teacher-classroom-settings-enrollment-code'>
        <div className='teacher-classroom-settings-enrollment-code__label form__label-text'>
          Class Enrollment Code
        </div>
        <div className='teacher-classroom-settings-enrollment-code__input'>
          <span className='teacher-classroom-settings-enrollment-code__input-badge'>
            {this.props.classroom.getInviteCode()}
          </span>
          <button
            className='teacher-classroom-settings-enrollment-code__input-regenerate button--green'
            onClick={() => this.setState({showModal: true})}
            type='button'
          >
            Regenerate
          </button>
        </div>
        {this.state.showModal && (
          <Modal ariaLabel='Generate a new enrollment code' handleClose={this.closeModal}>
            {({modalContentStyle}) => (
              <GenerateJoinCodeDialogue
                className={modalContentStyle}
                classroom={this.props.classroom}
                onSuccess={this.closeModal}
                handleClose={this.closeModal}
                hideCloseBtn={false}
                inModal
              />
            )}
          </Modal>
        )}
      </div>
    );
  }
}
